import { useQuery } from 'react-query'

import { useSpotify } from '@/store/integrations/spotify/useSpotify'

export function useQuerySpotifyTracks(query = '') {
  const { playlistService } = useSpotify()

  const { fn, key } = playlistService.queries.searchTracks

  return useQuery(key(query), () => fn(query), { enabled: Boolean(query) })
}
